
  export const calcAspectRatio = (aspectRatio) => {
    let split = aspectRatio.split("/");
    return !split[1]
      ? parseInt(split[0])
      : parseInt(split[0]) / parseInt(split[1]);
  };
